import * as React from "react";
import { graphql } from "gatsby"
import { useLocation } from "@reach/router"
import ContentModule from "../modules/content_module";
import LocRatingMap from "../components/map/loc-rating-map-details"
import Layout from "../components/Layout"
import { Container, Row, Col } from "react-bootstrap"
import AreaGuideBanner from "../components/AreaGuideBanner/AreaGuideBanner";
import Journey from "../components/Journey/Journey";
import Reviews from "../components/Reviews/Reviews";
import "../scss/branch-details.scss";
import FeaturesAreaGuide from "../components/Features/FeaturesAreaGuide";
import _ from "lodash";

// markup
const AreaGuideDetails = ({ data }) => {
    const location = useLocation();
    const { glstrapi: { areaGuide, globalModule } } = data; 

    let tab_list = [
        {
            "tab_name": "Property for Sale",
            "add_tab": "residential_sales"
        },
        {
            "tab_name": "Property to Rent",
            "add_tab": "residential_lettings"
        }
    ]

    if(process.env.GATSBY_SITE_NAME === "Stonehouse"){
        tab_list = [
            {
                "tab_name": "Property to Rent",
                "add_tab": "residential_lettings"
            }
        ]
    }

    // Get Map Details
    let mapItems = [];
    let mapItem = {};
    mapItem['lat'] = areaGuide.latitude
    mapItem['lng'] = areaGuide.longitude
    mapItem['id'] = areaGuide.id

    const mapMarkerImageShowFlag = 0;
    mapItems.push(mapItem);
    // Get Map Details

    let meta_data = areaGuide?.title ? { title: `${areaGuide?.title} Area Guide`, description: `Know more about ${areaGuide?.title} here. Contact one of our estate agents for assistance in finding the right property for you in ${areaGuide?.title}.` } : "";

    return (
        <div className="search-header detail-page area_guide_details">
            {areaGuide?.title &&
                <Layout seo_meta={meta_data} isJourneySec={true} menu_slug={"area-guide-details"}>
                    <>
                        <AreaGuideBanner area_guide_data={areaGuide} location={location} />

                        <section className="static-details">
                            <Container>
                                <Row>
                                    <Col>
                                        <div className="details-wrap">

                                            <ContentModule Content={areaGuide?.content} />
                                        </div>
                                    
                                    </Col>
                                </Row>
                            </Container>
                        </section>
                      
                        {areaGuide.latitude && areaGuide.longitude && 
                            <section className="map">
                                <div className="map-img">
                                    <LocRatingMap data={mapItems} />
                                </div>
                            </section>
                        }

                        <FeaturesAreaGuide area_name={_.trim(areaGuide?.title)} tab_list={tab_list} />

                        <Journey />
                    </>
                </Layout>
            }
        </div>
    )
}

export default AreaGuideDetails

export const query = graphql`
query areaGuideDetailQuery($id: ID!) {
    glstrapi { 
        globalModule {
            branch_statistics {
                id
                icon_class
                heading
                content
            }
        }

        areaGuide(id: $id) {
            id
            banner_image {
                url
                alternativeText
              }
            content
            imagetransforms
            latitude
            longitude
            publish
            slug
            title
        } 
    }
}`